module.exports = __webpack_public_path__ + "static/media/61KNonXoVYL._SL1200_.12d396e1.jpg";